module.exports = __webpack_public_path__ + "./assets/icons/Beach-34259.mp4";